// @flow

import React, { useEffect } from 'react'
import { getCookie } from '../lib/cookies'
require('intersection-observer')

import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill'

// OR: may also need to set as global property
global.EventSource = NativeEventSource || EventSourcePolyfill

type Props = {
  children: React$Node
}

const Layout = ({ children }: Props) => {
  useEffect(() => {
    const cookie = getCookie("country")
    if (window.location.pathname === "/" && cookie) {
      window.location.href = new URL(cookie, window.location.href)
    }
  }, [])

  return (
    <>
      <main
        id="everything"
        className="everything relative font-primary text-normal"
      >
        <div id="content">
          <section id="galacticnav"></section>
          <div id="header" className="header" style={{ zIndex: 35, minHeight: 76 }}></div>
          {children}
          <div id="footer" className="footer"></div>
        </div>
      </main>
    </>
  )
}

export default Layout
